// Peças visuais dos relatórios: barras de série única, medidor de progresso, selo de status
// e cartão de indicador. Cores só por tokens; o valor fica sempre visível (o detalhe no
// hover/foco complementa, nunca é o único jeito de ler o número).
import React, { useState } from 'react';
import { FiAlertTriangle, FiCheckCircle, FiClock, FiPauseCircle, FiXCircle } from 'react-icons/fi';

export function Barras({ itens, maximo, formatarValor = (v) => v, rotulo }) {
  const [ativo, setAtivo] = useState(null);
  const max = maximo ?? Math.max(1, ...itens.map((i) => i.valor));

  return (
    <ul className="rel-barras" aria-label={rotulo}>
      {itens.map((item, i) => {
        const proporcao = max > 0 ? Math.min(1, Math.max(0, item.valor / max)) : 0;
        const texto = `${item.prefixo ? `${item.prefixo} ` : ''}${item.rotulo}: ${formatarValor(item.valor)}${item.detalhe ? `. ${item.detalhe}` : ''}`;
        return (
          <li
            key={item.chave ?? i}
            className={`rel-barras__linha${ativo === i ? ' is-ativa' : ''}`}
            tabIndex={0}
            aria-label={texto}
            onMouseEnter={() => setAtivo(i)}
            onMouseLeave={() => setAtivo(null)}
            onFocus={() => setAtivo(i)}
            onBlur={() => setAtivo(null)}
          >
            <span className="rel-barras__rotulo">
              {item.prefixo && <span className="rel-barras__prefixo">{item.prefixo}</span>}
              <span className="rel-barras__texto">{item.rotulo}</span>
            </span>
            <span className="rel-barras__area" aria-hidden="true">
              <span className="rel-barras__barra" style={{ '--p': proporcao }} />
              <span className="rel-barras__valor">{formatarValor(item.valor)}</span>
            </span>
            {ativo === i && item.detalhe && (
              <span className="rel-barras__dica" role="tooltip">{item.detalhe}</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}

export function Medidor({ valor, total }) {
  const proporcao = total > 0 ? Math.min(1, valor / total) : 0;
  return (
    <span className="rel-medidor" title={`${valor} de ${total} etapas`}>
      <span className="rel-medidor__trilho" aria-hidden="true">
        <span className="rel-medidor__preenchido" style={{ '--p': proporcao }} />
      </span>
      <span className="rel-medidor__texto">{total ? `${valor}/${total}` : valor}</span>
    </span>
  );
}

const ICONES = { success: FiCheckCircle, danger: FiXCircle, warning: FiAlertTriangle, info: FiClock, neutral: FiPauseCircle };

// tom "neutral" usa o selo base (cinza), sem variante de cor
export function SeloStatus({ status }) {
  const Icone = ICONES[status.tom];
  return (
    <span className={status.tom === 'neutral' ? 'qz-badge' : `qz-badge qz-badge--${status.tom}`}>
      {Icone && <Icone aria-hidden="true" />}
      {status.rotulo}
    </span>
  );
}

export function Indicador({ rotulo, valor, apoio }) {
  return (
    <div className="rel-indicador">
      <span className="rel-indicador__rotulo">{rotulo}</span>
      <span className="rel-indicador__valor">{valor}</span>
      {apoio && <span className="rel-indicador__apoio">{apoio}</span>}
    </div>
  );
}
